var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-ellipsis',{attrs:{"text":_vm.text,"height":70,"isLimitHeight":_vm.isLimitHeight},nativeOn:{"click":function($event){_vm.isLimitHeight = !_vm.isLimitHeight}}})}
var staticRenderFns = []

export { render, staticRenderFns }